/**
 * @generated SignedSource<<68d3a8838ec4043750a08ad8a58f9f31>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AuthReason = "BAD_LEVEL" | "CREDENTIALS_REFUSED" | "INVALID_EMAIL" | "LINK_REFUSED" | "NAME_REQUIRED" | "NAME_TOO_LONG" | "NATIVE_LANGUAGE_IS_ENGLISH" | "PASSWORD_REFUSED" | "RESET_REQUESTED" | "SIGNUP_ACCEPTED" | "WEAK_PASSWORD" | "%future added value";
export type LogInInput = {
  email: string;
  password: string;
};
export type SignupViewLogInMutation$variables = {
  input: LogInInput;
};
export type SignupViewLogInMutation$data = {
  readonly logIn: {
    readonly ok: boolean;
    readonly reason: AuthReason | null | undefined;
  };
};
export type SignupViewLogInMutation = {
  response: SignupViewLogInMutation$data;
  variables: SignupViewLogInMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "LogInPayload",
    "kind": "LinkedField",
    "name": "logIn",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "reason",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SignupViewLogInMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "SignupViewLogInMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "75dec0f0cbe05edcc206614c5fedb695",
    "id": null,
    "metadata": {},
    "name": "SignupViewLogInMutation",
    "operationKind": "mutation",
    "text": "mutation SignupViewLogInMutation(\n  $input: LogInInput!\n) {\n  logIn(input: $input) {\n    ok\n    reason\n  }\n}\n"
  }
};
})();

(node as any).hash = "7a8f4af2dde1fb9e2a5943898063fb55";

export default node;
